import { createFileRoute } from '@tanstack/react-router';
import {
  campaignsList,
  deliveryPlacements,
  productionsList,
  reportingByAudience,
  reportingQuery,
} from '@/api/resources';
import { warm, warmBackground } from '@/api/loaders';
import { requireCapability } from '@/lib/route-guards';
import { DeliveryReports } from '@/screens/delivery';
import {
  deliveryPlacementRequest,
  operationalFreshnessRequest,
  operationalReportDateQuery,
  parseDeliveryReportSearch,
  serializeOperationalReportSearch,
  updateDeliveryReportSearch,
} from '@/lib/operational-report-search';
import type { DeliveryReportSearchPatch } from '@/lib/operational-report-search';

export const Route = createFileRoute('/reports/delivery')({
  beforeLoad: requireCapability('reports_view'),
  validateSearch: parseDeliveryReportSearch,
  loaderDeps: ({ search }) => search,
  // Search-driven route: no skeleton for an in-screen navigation (router.ts).
  pendingMs: Infinity,
  loader: ({ context, deps }) => {
    warmBackground(
      context.queryClient,
      campaignsList({}),
      productionsList({}),
      reportingByAudience(operationalReportDateQuery(deps)),
    );
    return warm(
      context.queryClient,
      deliveryPlacements(deliveryPlacementRequest(deps)),
      reportingQuery(operationalFreshnessRequest(deps)),
    );
  },
  component: Page,
});

function Page() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <DeliveryReports
      search={search}
      onSearchChange={(
        patch: DeliveryReportSearchPatch,
        options?: { replace?: boolean },
      ) => {
        void navigate({
          search: (current) => serializeOperationalReportSearch(
            updateDeliveryReportSearch(current, patch),
          ),
          replace: options?.replace,
        });
      }}
    />
  );
}
